var map = {
	"./e-commerce/0.png": 915,
	"./food-search/0.png": 499,
	"./park-search/0.png": 148,
	"./quiz/0.png": 654,
	"./repository-search/0.png": 537,
	"./review-blog/0.png": 366,
	"./scheduler/0.png": 742
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 83;